import { srLatn } from "../../../../date-fns/locale/sr-Latn.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    srLatn
  }
};